<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_5048)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_5048)" />
    </g>
    <g clip-path="url(#clip0_3254_5048)">
      <path
        d="M9.74991 11.75C9.74991 11.3344 10.0843 11 10.4999 11H11.4999C11.9155 11 12.2499 11.3344 12.2499 11.75V15.5H12.7499C13.1655 15.5 13.4999 15.8344 13.4999 16.25C13.4999 16.6656 13.1655 17 12.7499 17H10.2499C9.83429 17 9.49991 16.6656 9.49991 16.25C9.49991 15.8344 9.83429 15.5 10.2499 15.5H10.7499V12.5H10.4999C10.0843 12.5 9.74991 12.1656 9.74991 11.75ZM11.7093 20.6625C11.5062 20.4313 11.1374 20.4469 10.9593 20.7L10.6093 21.1844C10.3687 21.5219 9.89991 21.6 9.56241 21.3594C9.22491 21.1188 9.14679 20.65 9.38741 20.3125L9.73429 19.825C10.4749 18.7875 11.9937 18.7125 12.8343 19.6719C13.4999 20.4344 13.4843 21.575 12.7999 22.3188L11.7124 23.5H12.7499C13.1655 23.5 13.4999 23.8344 13.4999 24.25C13.4999 24.6656 13.1655 25 12.7499 25H9.99991C9.70304 25 9.43116 24.825 9.31241 24.55C9.19366 24.275 9.24679 23.9594 9.44679 23.7406L11.6968 21.3031C11.8624 21.1219 11.8655 20.8469 11.7062 20.6625H11.7093ZM15.9999 12H23.9999C24.553 12 24.9999 12.4469 24.9999 13C24.9999 13.5531 24.553 14 23.9999 14H15.9999C15.4468 14 14.9999 13.5531 14.9999 13C14.9999 12.4469 15.4468 12 15.9999 12ZM15.9999 17H23.9999C24.553 17 24.9999 17.4469 24.9999 18C24.9999 18.5531 24.553 19 23.9999 19H15.9999C15.4468 19 14.9999 18.5531 14.9999 18C14.9999 17.4469 15.4468 17 15.9999 17ZM15.9999 22H23.9999C24.553 22 24.9999 22.4469 24.9999 23C24.9999 23.5531 24.553 24 23.9999 24H15.9999C15.4468 24 14.9999 23.5531 14.9999 23C14.9999 22.4469 15.4468 22 15.9999 22Z"
        fill="white" />
    </g>
    <defs>
      <filter id="filter0_d_3254_5048"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.65098 0 0 0 0 0.0588235 0 0 0 0 0.2 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_5048" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_5048" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_5048"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#F0023B" />
        <stop offset="1" stop-color="#A60F33" />
      </linearGradient>
      <clipPath id="clip0_3254_5048">
        <rect width="16" height="16" fill="white" transform="translate(9 10)" />
      </clipPath>
    </defs>
  </svg>
</template>
